/**
 * Size of a tile on the personal home page, expressed in grid cells (columns x rows).
 *
 * Mirrors {@code com.mvs.backend.ui.logic.UiHomeTileSizeEnum}. The backend enum is persisted
 * ORDINAL and serialized as its ordinal number, so the member ORDER here is the contract:
 * s1x1=0, s2x2=1, s4x2=2, s4x4=3. Append only, never reorder.
 */
export enum UiHomeTileSizeEnum {

    s1x1,
    s2x2,
    s4x2,
    s4x4,
}
